import Select from "shared/components/Select";

const Budget = ({
  options,
  value,
  onChange,
  onClear,
  disabled = false,
  translation,
}) => {
  return (
    <div className="b2c__budget-container">
      <span className="b2c__budget-container--title">
        {translation.NEEDS.BUDGET.TITLE}
      </span>
      <Select
        allowClear={true}
        placeholder={translation.NEEDS.BUDGET.PLACEHOLDER}
        options={options}
        value={value}
        onChange={(e) => {
          if (e === undefined && onClear) {
            onClear();
          } else if (e) {
            onChange(e);
          }
        }}
        disabled={disabled}
      />
    </div>
  );
};

export default Budget;
